import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';
import { ApplicantRequest, IApplicantsService, RegisterForeign, RelationshipResponse, RequestCodeRegister } from './applicants.interface';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicantsService implements IApplicantsService {
  cache = new Map<string, RelationshipResponse>();

  constructor(
    private httpClient: HttpClient,
    private readonly authService: AuthService,
    ) { }

  getCurrentApplicant(): Observable<ApplicantRequest> {
    return this.httpClient.get<ApplicantRequest>(environment.apiPublicUrl + '/registration/applicant?applicant=' + this.authService.getCurrentUser().documentNumber + '&language=' + LanguageUtils.getLanguage());
  }

  getApplicant(identificationNumber: string): Observable<ApplicantRequest> {
    return this.httpClient.get<ApplicantRequest>(environment.apiPublicUrl + '/registration/applicant?applicant=' + identificationNumber + '&language=' + LanguageUtils.getLanguage());
  }

  createApplicant(applicantRequest: ApplicantRequest): Observable<string> {
    return this.httpClient.post<string>(environment.apiPublicUrl + '/registration/applicant', applicantRequest);
  }

  getRelationships(): Observable<RelationshipResponse> {
    const cached = this.cache.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<RelationshipResponse>(environment.apiPublicUrl + '/registration/applicant/relationships?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache.set(LanguageUtils.getLanguage(), data))
      );
    }
  }

  updateApplicant(applicantRequest: ApplicantRequest): Observable<string> {
    return this.httpClient.post<string>(environment.apiPublicUrl + '/registration/applicant', applicantRequest);
  }

  requestCodeRegister(requestCodeRegister: RequestCodeRegister): Observable<void> {
    return this.httpClient.post<void>(environment.apiAuthUrl + '/management/user?language=' + LanguageUtils.getLanguage(), requestCodeRegister);
  }

  deleteApplicant(identificationNumber: string): Observable<string> {
    return this.httpClient.delete<string>(environment.apiPublicUrl + '/registration/applicant?applicant=' + identificationNumber + '&language=' + LanguageUtils.getLanguage());
  }

  registerForeignApplicant(applicantRequest: RegisterForeign): Observable<string> {
    return this.httpClient.post<string>(environment.apiPublicUrl + '/registration/foreign?language=' + LanguageUtils.getLanguage(), applicantRequest);
  }
}
